import { type SVGProps } from "react";
const IconNavDoc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.81 20H2.38a2.384 2.384 0 0 1-2.38-2.381V2.381A2.384 2.384 0 0 1 2.381 0h7.362a2.392 2.392 0 0 1 1.703.714l4.066 4.162c.436.445.68 1.044.678 1.667v3.548a.476.476 0 0 1-.952 0V6.543c0-.374-.146-.733-.407-1L10.764 1.38A1.432 1.432 0 0 0 9.743.952H2.38A1.429 1.429 0 0 0 .952 2.381v15.238a1.429 1.429 0 0 0 1.429 1.429h11.428c.18 0 .358-.034.524-.103a.477.477 0 0 1 .363.881 2.318 2.318 0 0 1-.886.174Z"
    />
    <path
      fill="currentColor"
      d="M15.519 6.19h-3.138A2.384 2.384 0 0 1 10 3.81V.624a.476.476 0 0 1 .952 0V3.81a1.429 1.429 0 0 0 1.429 1.428h3.138a.476.476 0 1 1 0 .952ZM14.762 19.93a.948.948 0 0 1-.528-.159l-1.53-1.02a7.127 7.127 0 0 1-3.18-5.941v-.816a.957.957 0 0 1 .734-.926 14.25 14.25 0 0 0 3.988-1.8.952.952 0 0 1 1.032 0 14.243 14.243 0 0 0 3.988 1.8.958.958 0 0 1 .734.926v.816a7.127 7.127 0 0 1-3.181 5.943l-1.529 1.02a.949.949 0 0 1-.528.157Zm0-9.861a15.191 15.191 0 0 1-4.274 1.924l-.012.817a6.177 6.177 0 0 0 2.757 5.15l1.529 1.018 1.529-1.02a6.178 6.178 0 0 0 2.757-5.148v-.816a15.239 15.239 0 0 1-4.286-1.925Z"
    />
    <path
      fill="currentColor"
      d="M14.286 15.714a.476.476 0 0 1-.337-.14l-.952-.952a.476.476 0 0 1 .673-.673l.616.616 1.568-1.568a.476.476 0 0 1 .673.673l-1.905 1.905c-.089.089-.21.14-.336.14ZM7.143 4.762h-3.81a.476.476 0 1 1 0-.952h3.81a.476.476 0 0 1 0 .952ZM10 7.619H3.333a.476.476 0 1 1 0-.952H10a.477.477 0 0 1 0 .952ZM10.952 10.476H3.333a.476.476 0 0 1 0-.952h7.62a.476.476 0 1 1 0 .952ZM8.095 13.333H3.333a.476.476 0 1 1 0-.952h4.762a.476.476 0 1 1 0 .952ZM8.095 16.19H3.333a.476.476 0 0 1 0-.952h4.762a.476.476 0 0 1 0 .953Z"
    />
  </svg>
);
export default IconNavDoc;
